import utils from './utils'
import * as asd from 'dat.gui'

/* //TODO 

*Stop in case of overgroving
*add more effects (shading, blur, sparks etc.)
*make git repository
*hide dat.GUI 
*add soundefects

*/

// GUI BOX FOR TWEAK 
//const gui = new asd.GUI();
const canvas = document.querySelector('canvas')
const c = canvas.getContext('2d')
const properties = {
  starving: 0.1,
  calories: 0.16,
  speed: 0.13

 /* //devmode:
 starving: 0.5,
 calories: 0,
 speed: 1
 */
}

canvas.width = innerWidth
canvas.height = innerHeight

const mouse = {
  x: innerWidth / 2,
  y: innerHeight / 2
}

const colors = ['#DE9151', '#F34213', '#2E2E3A', '#BC5D2E']


/*
//GUI Tweak options
gui.add(properties, 'starving', 0.001, 0.1);
gui.add(properties, 'calories', 0.001, 1);
gui.add(properties, 'speed', 0.010, 0.200);
*/

// Event Listeners
addEventListener('mousemove', (event) => {
  mouse.x = event.clientX
  mouse.y = event.clientY
})

addEventListener('resize', () => {
  canvas.width = innerWidth
  canvas.height = innerHeight

  init()
})

document.getElementById("continuen").addEventListener("click", function(){
  turnOffResults()
});

function maketopten(arr){

  let list = document.getElementById("#resultul");
  let topten = [];

  for(let i=0, len = arr.length; i<len; ++i){
    topten.push([i, arr[i]])
  }

  topten.sort(function(t1, t2){
    return t2[1] - t1[1] || t1[0] - t2[0];
  });

  // shorten array to correct size
  topten.length = 5;

  for(let i=0; i< topten.length; i++){
    let elem = document.getElementById(i)
    elem.innerHTML = '';
    elem.appendChild(document.createTextNode(topten[i][1]));
    console.log(topten[i][1])
  }
}

// Objects
class Ball {
  constructor(x, y, radius, color, xp) {
    this.x = x
    this.y = y
    this.radius = radius
    this.color = color
    this.xp = xp
  }

  draw() {
    c.beginPath()
    c.arc(this.x, this.y, this.radius, 0, Math.PI * 2, false)
    c.fillStyle = this.color
    c.fill()
    c.closePath()
  }
  addxp(){
    this.xp ++
  }
  moveBall() {
    //get the distance between the mouse and the ball on both axes
    //walk only the an eight of the distance to create a smooth fadeout
    var dx = (mouse.x - this.x) * properties.speed;
    var dy = (mouse.y - this.y) * properties.speed;
    //calculate the distance this would move ...
    var distance = Math.sqrt(dx*dx + dy*dy);
    //... and cap it at 5px
    if(distance > 5){
      dx *= 5/distance;
      dy *= 5/distance;
    }

    this.x += dx;
    this.y += dy;
  }

  grow(size){
    this.radius += size
  }

  starve(speedOfstarving){
    if(this.radius>1){
    this.radius -= speedOfstarving
  }else if(this.radius<=1){
      gameresults.push(this.xp)
      maketopten(gameresults)
      this.radius = 50;
      this.xp = 0;
      turnOnResults()
  }
  }
  update() {
    this.moveBall()
    this.draw()
    this.starve(properties.starving)
  };
}

class Food {
  constructor(x, y, radius, color, id, status) {
    this.x = x
    this.y = y
    this.radius = radius
    this.color = color
    this.id = id
    this.status = status
  }

  draw() {
    c.beginPath()
    c.arc(this.x, this.y, this.radius, 0, Math.PI * 2, false)
    c.fillStyle = this.color
    c.fill()
    c.closePath()
  }

  movefood(){
//move the food in the future
  }

  update() {
    this.draw()
      if(utils.distance(this.x, this.y, ball.x, ball.y) < ball.radius){
        if(this.status==1){
         
          if(this.radius>0){
            this.radius--
            ball.grow(properties.calories)
           
          }else if(this.radius==0){
            this.status = 0;
            makeOneFood(1)
            ball.addxp()
          }
      }
    }
  }
}

// Implementation
let run = true;
let objects
let ball;
let foodarray = []
let gameresults = [0,0,0,0,0,0,0,0,0,0]

function makeOneFood(num){
  for(let i =0; i < num; i++){
  foodarray.push(new Food(utils.randomIntFromRange(0,canvas.width),utils.randomIntFromRange(0,canvas.height),10,utils.randomColor(colors),i, 1))
  }
}
function turnOffResults(){
  document.getElementById("overlay").style.display = "none";
  document.getElementById("resultboxOut").style.visibility = "hidden";
  run=true;
}
function turnOnResults(){
  document.getElementById("overlay").style.display = "block";
  document.getElementById("resultboxOut").style.visibility = "visible";
  run = false;
}
function init() {
  objects = []
  ball = new Ball(canvas.width/2,canvas.height/2,50,'blue',0)
  for (let i = 0; i < 1; i++) {
      objects.push(ball)
  }
  run = true;
}


// Animation Loop
function animate() {
  requestAnimationFrame(animate)
  if(run){
    
  c.fillStyle = 'rgba(255,255,255, 0.5)'
  c.fillRect(0, 0, canvas.width, canvas.height)
  c.font= '220px arial'
  c.strokeText(ball.xp,canvas.width/2-110, canvas.height/2)
  
   objects.forEach(object => {
    object.update()
   })
   foodarray.forEach(Food => {
     Food.update()
   } )
  }
  }


init()
makeOneFood((canvas.width*canvas.height)/20000)
animate()
  